export default function Router($stateProvider) {
    "ngInject";

    $stateProvider
        .state({
            name: "media",
            url: "/app/media",
            template: "<media></media>",
            resolve: {
                $title: () => "Media | UpReach Cloud"
            }
        });
}


// WEBPACK FOOTER //
// ./sources/components/media/media.router.js